import { test } from 'ramda';

const isRootRelativeURL = test(/^\//);

export const getDomain = /* istanbul ignore next */ () =>
  process.env.RAZZLE_DOMAIN;

/**
 * A function to prefix an url with server root (if it is define)
 *
 * @param {string} url
 * @return {string}
 * @example fromRoot('/toto') === https://www.trololo/toto
 */
export const fromRoot = (url) => {
  if (isRootRelativeURL(url)) {
    return `${process.env.RAZZLE_S3_PREFIX}/public${url}`;
  }
  return url;
};
